import React, { ReactElement, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API, ApiErrorHandler } from "../../../services/api";
import { SeminarInterface } from '../../../interfaces/SeminarInterface';
import { PaginatedListInterface } from '../../../interfaces/PaginatedList';
import { formatDate, range, useQuery } from '../../../utils/helper';
import { useAuth } from "../../../hooks/useAuth";

export default (): ReactElement => {
  const { logout } = useAuth();
  const [seminars, setSeminars] =
    useState<PaginatedListInterface<SeminarInterface>>();

  const page = useQuery().get('page');

  useEffect(() => {
    (async () => {

      try{
        await API.get(`host/seminars?page=${page ? page : 1}`);
      }catch (e){
        ApiErrorHandler(e, {
          onUnauthorizedError: logout
        })
      }

    })();
  }, [page]);

  return (
    <div className="content">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Seminare</h1>
            </div>
            <div
              className="col-sm-6"
              style={{
                textAlign: 'right',
              }}
            >
              <Link to={`/seminars/addSeminar`}>
                <button type="button" className="btn btn-primary btn-sm">
                  Neues Seminar anlegen
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid">
        <div className="card">
          <div className="card-body table-responsive p-0">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Geplanter Start</th>
                </tr>
              </thead>
              <tbody>
                {seminars?.items &&
                  seminars?.items.map((seminar, key) => (
                    <tr key={key}>
                      <td>
                        <Link to={`/seminars/seminars/${seminar.id}`}>
                          {seminar.title}
                        </Link>
                      </td>
                      <td>
                        <Link to={`/seminars/seminars/${seminar.id}`}>
                          {formatDate(seminar?.scheduledStart)} Uhr
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              {range(seminars?.numberOfPages).map((page, key) => (
                <li className="page-item" key={key}>
                  <Link
                    className="page-link"
                    to={`seminars/seminars?page=${page}`}
                  >
                    {page}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
